// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"KXBBb0A","box-content":"jfDHUuu","boxContent":"jfDHUuu","box":"AO_FtRB"};